// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#zoomCharts_demo__4pByJ {\n  height: 100%;\n  background-color: var(--color-white);\n  border-radius: 5px;\n}", "",{"version":3,"sources":["webpack://./src/components/ZoomCharts/zoomCharts.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,oCAAA;EACA,kBAAA;AACF","sourcesContent":["#demo {\n  height: 100%;\n  background-color: var(--color-white);\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"demo": "zoomCharts_demo__4pByJ"
};
export default ___CSS_LOADER_EXPORT___;
